import Api from '../shared/Api';

class ProductsApi {
    static getProducts(): any {
        return new Promise<any>(
            (resolve: (response: any) => void, reject: (error: string) => void) => {
                new Api()
                    .get('/products')
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static createProduct(product: any): any {
        return new Promise<any>(
            (resolve: (response: any) => void, reject: (error: any) => void) => {
                new Api()
                    .post('/products', product)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static editProduct(product: any): any {
        return new Promise<any>(
            (resolve: (response: any) => void, reject: (error: any) => void) => {
                new Api()
                    .put('/products', product)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }
}

export default ProductsApi;
